import React from "react";
import "./index.css";

export default function Contact() {
  return (
    <>
      <h1>Contact Jolanta</h1>

      <section className="contact-form">
        <form action="https://formspree.io/f/mnjjqakn" method="POST">
          <input type="text" name="name" placeholder="Your Name" required />
          <input type="email" name="email" placeholder="Your Email" required />
          <input type="text" name="subject" placeholder="Subject" required />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="6"
            required
          ></textarea>
          <button type="submit">Send Message</button>
        </form>
      </section>
    </>
  );
}
